module.exports = __webpack_public_path__ + "913b48ca5c6831e58a07ff808a8e44ba.png";